module.exports = "\r\n<p [innerHtml]=\"texto\"></p>"